/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FmrVMIEnumerableResponseVM } from '../models/FmrVMIEnumerableResponseVM';
import type { StringResponseVM } from '../models/StringResponseVM';
import type { UsZipInfoVMResponseVM } from '../models/UsZipInfoVMResponseVM';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UtilityService {
    /**
     * @param zipCode
     * @returns UsZipInfoVMResponseVM Success
     * @throws ApiError
     */
    public static getApiUtilityCityStateInfoByZip(
        zipCode: string,
    ): CancelablePromise<UsZipInfoVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Utility/city-state-info-by-zip/{zipCode}',
            path: {
                'zipCode': zipCode,
            },
        });
    }
    /**
     * @param zipCode
     * @returns FmrVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiUtilityFmr(
        zipCode: string,
    ): CancelablePromise<FmrVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Utility/fmr/{zipCode}',
            path: {
                'zipCode': zipCode,
            },
        });
    }
    /**
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static getApiUtilityAppVer(): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Utility/app-ver',
        });
    }
    /**
     * @returns any Success
     * @throws ApiError
     */
    public static getApiUtilityPlaidTest(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Utility/plaid-test',
        });
    }
}
